import Http from '@/services/http';
import {
  ChartQuery,
  ChromatographyEvolutionChart,
  ChromatographySamplePagedResponse,
  PagedRequest,
  ReprocessSampleRequest,
} from 'sigma-mappings';
import msis127Error from '@/domain/data/installation/engineering/cromaMSIS127ErrorHandler';
import { sampleFieldsDefinitions } from '@/domain/data/installation/engineering/chromatography/sample';
import translate from '@/services/translate';

const urls = {
  pagedSamples: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/listagem`,
  reprocessPendingSamples: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/reprocessar`,
  getEvolutionCharts: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/evolucao`,
  deleteSample: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras/deletar`,
};

function chartMap(data) {
  return data.map((gas) => {
    const fieldDefinition = sampleFieldsDefinitions[gas.nameField];
    const name = fieldDefinition ? translate(fieldDefinition.name) : gas.nameField;
    return {
      ...gas,
      name,
    };
  });
}

const getGasFromTaxField = field => field.replace('Taxa', '');

function chartRateMap(data) {
  return data.map((gas) => {
    const fieldDefinition = sampleFieldsDefinitions[getGasFromTaxField(gas.nameField)];
    const name = fieldDefinition ? translate(`${fieldDefinition.name}-rate`) : gas.nameField;
    return {
      ...gas,
      name,
    };
  });
}

export default {
  /**
   * Obtém uma listagem paginada das amostras de cromatografia.
   * @param {number} payload.pageSize
   * @param {number} payload.page
   * @param {GUID} assetModuleId
   * Entrega 1 não terá filtros, apenas a estrutura paginada.
   */
  getPagedSampleList(assetModuleId, payload) {
    const http = new Http();
    const mappedPayload = new PagedRequest(payload);
    return http
      .post(urls.pagedSamples(assetModuleId), mappedPayload)
      .then(({ data }) => new ChromatographySamplePagedResponse(data));
  },
  /**
   * Exclusão de amostras cromatografia.
   * @param {GUID} assetModuleId
   * @param {GUID} ids
   */
  deleteSample(assetModuleId, ids) {
    const { msis127ErrorHandler, errorHandling } = msis127Error;
    const http = new Http({
      errorHandling,
    });
    return http
      .post(urls.deleteSample(assetModuleId), { ids })
      .then(({ data }) => data)
      .catch(msis127ErrorHandler);
  },
  /**
   * Reprocessar amostras pendentes.
   * @param {string } userName
   * @param {GUID} assetModuleId
   */
  reprocessPendingSamples(assetModuleId, userName) {
    const http = new Http();
    const mappedPayload = new ReprocessSampleRequest({ userName });
    return http
      .post(urls.reprocessPendingSamples(assetModuleId), mappedPayload)
      .then(({ data }) => data);
  },
  /**
   * Retorna os gráficos de taxas e gases.
   * @param {GUID} assetModuleId
   * @param {Object} chartFilters
   */
  getEvolutionCharts(assetModuleId, chartFilters) {
    const http = new Http();
    const chartQuery = new ChartQuery(chartFilters);
    return http
      .get(urls.getEvolutionCharts(assetModuleId), { params: chartQuery })
      .then(({ data }) => {
        const mappedData = new ChromatographyEvolutionChart(data);
        mappedData.gases = chartMap(mappedData.gases);
        mappedData.rates = chartRateMap(mappedData.rates);
        return mappedData;
      });
  },
};
